import { Image } from "@components/Image";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { ICON_PATHS } from "@configs/icons";

export const NotFound = () => (
	<div className="h-screen">
		<Stack align="center" justify="center" className="relative h-[90vh] px-12.5 py-7.5 text-center">
			<div className="mx-auto mb-12.5 h-16.25 w-30">
				<Image width={120} height={65} src={ICON_PATHS.LOGO_MINI} alt="logo" />
			</div>
			<Typography type="span" size="5xl" weight="bold" align="center" color="text" className="leading-14">
				404
			</Typography>
			<Typography type="span" size="2xl" align="center" color="text" className="mt-5 leading-7">
				Sorry, we couldn’t find that page
			</Typography>
		</Stack>
	</div>
);
